import { render, staticRenderFns } from "./operator-requests-quota.vue?vue&type=template&id=25504f4e&lang=pug&"
import script from "./operator-requests-quota.vue?vue&type=script&lang=js&"
export * from "./operator-requests-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports